import { render, staticRenderFns } from "./SingleOrder.vue?vue&type=template&id=afb9050e&scoped=true&"
import script from "./SingleOrder.vue?vue&type=script&lang=js&"
export * from "./SingleOrder.vue?vue&type=script&lang=js&"
import style0 from "./SingleOrder.vue?vue&type=style&index=0&id=afb9050e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afb9050e",
  null
  
)

export default component.exports